import { useCallback, useState } from 'react';
import { getErrorMessage } from '@/shared/data/errors';

type MutationErrorState = { message: string | null; nonce: number };

export const useMutationError = (): {
  error: string | null;
  setError: (err: unknown) => void;
  clearError: () => void;
  errorNonce: number;
} => {
  const [state, setState] = useState<MutationErrorState>({ message: null, nonce: 0 });

  const handleError = useCallback((err: unknown) => {
    setState((prev) => ({ message: getErrorMessage(err), nonce: prev.nonce + 1 }));
  }, []);

  const clearError = useCallback(() => {
    setState((prev) => ({ message: null, nonce: prev.nonce + 1 }));
  }, []);

  return { error: state.message, setError: handleError, clearError, errorNonce: state.nonce };
};
